import Api from "./Api";
import {mixpanelReset, mixpanelIdentifyAccount} from "./mixpanelClient";

class Auth {
  register = (firstName, lastName, email, password, optinMail, optinData, policy, action) => {
    let user = {
      firstname: firstName,
      lastname: lastName,
      email: email,
      password: password,
      optin_mail: optinMail,
      optin_data: optinData,
      policy: policy,
      action: action
    };
    return new Promise((resolve, reject) => {
      Api.post('/register', user).then(response => {
        if (typeof (response.data) !== 'undefined' && response.data !== null && response.data[0] === 1000) {
          resolve();
        }

        reject(response.data[0] || null);
      }).catch(() => reject(null));
    })
  };

  confirm = (code, email) => {
    let payload = {
      confirmation_code: code,
      email: email
    };

    return new Promise((resolve, reject) => {
      Api.post('/confirm', payload).then(response => {
        if (response?.data?.response?.status === 1000) {
          resolve();
        }
        reject(response?.data?.response?.status || null);
      }).catch(() => reject(null));
    });
  };

  forgotPassword = (email) => {
    return new Promise((resolve, reject) => {
      Api.post(
        '/reset',
        {
          email: email
        }
      ).then(response => {
        if (((((((response.data) || {}).response || {}).status || {})[0] || 0) === 1000)) {
          resolve(response.data.response.status[0]);
        }

        reject(response.data[0] || null);
      }).catch(() => reject(null));
    });
  };

  reset = (email, password, token) => {
    return new Promise((resolve, reject) => {
      Api.post(
        '/reset',
        {
          email: email,
          password: password,
          reset_token: token
        }
      ).then(response => {
        if (((((((response.data) || {}).response || {}).status || {})[0] || 0) === 1000)) {
          resolve(response.data.response.status[0]);
        }

        reject(response.data[0] || null);
      }).catch(() => reject(null));
    });
  };

  login = (email, password) => {
    return new Promise((resolve, reject) => {
      Api.post(
        '/signin',
        {
          email: email,
          password: password
        }
      ).then(response => {
        const token = response.data?.response?.data?.token;
        const accountId = response.data?.response?.data?.id;
        const registeredEmail = response.data?.response?.data?.email;

        if (token) {
          this.setAuth(token, 'login', registeredEmail, accountId);
          mixpanelIdentifyAccount(accountId);
          resolve(token);
        }

        reject(response.data?.response?.status || null);
      }).catch(() => reject(null));
    });
  };

  logout = () => {
    this.clearData();
    mixpanelReset();
  };

  getToken = () => localStorage.getItem('token');
  getEmail = () => localStorage.getItem('account-email');
  getAccountId = () => localStorage.getItem('account-id');

  getAccountType = () => localStorage.getItem('account-type') || 'token';
  setAccountType = type => localStorage.setItem('account-type', type);

  setAuth = (token, accountType, email = null, accountId = null) => {
    localStorage.setItem("token", token);
    localStorage.setItem('account-type', accountType);

    if (email) {
      localStorage.setItem('account-email', email);
    }

    if (accountId) {
      localStorage.setItem('account-id', accountId);
    }
  }

  checkLogin = () => {
    return new Promise((resolve, reject) => {
      if (this.isLoggedIn()) {
        Api.get('/auth/check').then(response => {
          const status = response?.data?.response?.status?.[0] || 0
          if (status === 1000) {
            resolve()
          } else {
            reject(status)
          }
        })
      } else {
        reject(0)
      }
    })
  }

  checkValidToken = token => {
    return new Promise((resolve, reject) => {
      Api.get(`/auth/check-token/${token}`).then(response => {
        const status = (((((response.data) || {}).response || {}).status || {})[0] || 0)
        if (status === 1000) {
          resolve()
        } else {
          reject(status)
        }
      })
    })
  };

  isLoggedIn = () => localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined;

  clearData = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("account-type");
    localStorage.removeItem("account-email");
  };

  setDataSettings = (dataParams) => Api.post('/profile/settings', dataParams, {bike_cat: 'race'});

  getDataSettings = () => {
    return new Promise((resolve, reject) => {
      Api.get('/profile/settings', {bike_cat: 'race'})
        .then((response) => {
          let dataSettings = ((((response.data || {}).response || {}).data || {}).settings) || {};
          resolve(dataSettings);
        })
        .catch(() => reject())
    })
  };
}
// eslint-disable-next-line
export default new Auth();
